const BRANDS = [
  "Rolex",
  "Patek Philippe",
  "Audemars Piguet",
  "Vacheron Constantin",
  "Richard Mille",
  "F.P. Journe",
  "Breguet",
  "Jaeger-LeCoultre",
  "Blancpain",
  "Omega",
  "Piaget",
  "Chopard",
];

export default function Marquee() {
  const items = [...BRANDS, ...BRANDS];
  return (
    <div
      className="relative border-y border-white/[0.06] bg-coal/40 py-7 overflow-hidden"
      data-testid="houses-marquee"
    >
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent z-10 pointer-events-none" />
      <div className="flex w-max animate-marquee">
        {items.map((b, i) => (
          <span key={`${b}-${i < BRANDS.length ? "a" : "b"}`} className="flex items-center shrink-0">
            <span className="font-display text-lg sm:text-xl tracking-[0.25em] uppercase text-ivory/50 hover:text-gold transition-colors duration-500 px-8">
              {b}
            </span>
            <span className="text-gold/40 text-[8px]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
